import { styled } from '@goodfynd/theme';
import { Button } from '@goodfynd/ui';

export const GroupNameContainer = styled('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

export const StyledAddButton = styled(Button, {
  flex: 1,
  marginLeft: 'auto',
});

export const StyledImageContainer = styled('div', {
  height: 248,
  position: 'relative',
});

export const StyledModalContent = styled('div', {
  padding: 24,
  paddingBottom: 112,
  '@sm': {
    padding: 16,
    paddingBottom: 88,
  },
});

export const StyledProductOptionsContainer = styled('section', {
  position: 'relative',
});

export const StyledProductOptionsContainerDisabled = styled('section', {
  bottom: 0,
  height: '100%',
  left: 0,
  position: 'absolute',
  width: '100%',
  zIndex: 1,
});

export const StyledProductOptionsGroup = styled('section', {
  marginTop: 24,
});

export const StyledRequestsContainer = styled('section', {
  // backgroundColor: '$Neutral01',
  margin: '0 -24px',
  marginTop: 16,
  padding: 24,
});

export const StyledStickyBottom = styled('div', {
  alignItems: 'center',
  display: 'flex',
  bottom: 0,
  gap: 24,
  justifyContent: 'space-between',
  padding: '16px 24px',
  '@sm': {
    padding: '8px 16px',
  },
});
